import { generatePath } from "react-router-dom";
import { deserialize, serialize } from "serializr";
import { NotificationTypes } from "../../enums/notificationTypes";
import axiosInstance from "../../interceptor/axiosInstance";
import _axiosInstance from "../../interceptor/_axiosInstance";
import { ExerciseModal } from "../../models/ExerciseModal/Exercise.model";
import {
  BULK_EXERCISE_QUESTIONS,
  EXERCISES,
  EXERCISES_ID,
  EXERCISE_POSITION,
  BULK_EXERCISE_QUESTIONS_DOC
} from "../../routes/routeConstants/apiRoutes";
import Notification from "../../shared/components/Notification";

interface ExcerciseFilterParams {
  chaptor_id?: string | number | undefined;
  search?: string | undefined;
}

export default class {
  static getExcerciseByFilter(
    { ...param }: ExcerciseFilterParams,
    onSuccess: (data: any) => void,
    onError: () => void
  ) {
    const params = JSON.parse(JSON.stringify(param));
    return axiosInstance
      .get(EXERCISES, {
        params,
      })
      .then((response) => {
        const exercises = deserialize(
          ExerciseModal,
          response?.data?.excercises
        );
        onSuccess(exercises);
      })
      .catch((error) => {
        console.log(error?.message);
        onError();
      });
  }

  static createExercise(
    payload: any,
    onSuccess: (exercise: ExerciseModal) => void,
    onError: () => void
  ) {
    const exercise = serialize(Object.assign(new ExerciseModal(), payload));
    return axiosInstance
      .post(EXERCISES, exercise)
      .then((response) => {
        const exercise = deserialize(ExerciseModal, response?.data?.excercise);
        onSuccess(exercise);
      })
      .catch((error) => {
        console.log(error?.message);
      });
  }

  static updateExercise(
    id: any,
    payload: any,
    onSuccess: (exercise: ExerciseModal) => void,
    onError: () => void
  ) {
    const exercise = serialize(Object.assign(new ExerciseModal(), payload));
    return axiosInstance
      .put(
        generatePath(EXERCISES_ID, {
          id,
        }),
        exercise
      )
      .then((response) => {
        const exercise = deserialize(ExerciseModal, response?.data?.excercise);
        onSuccess(exercise);
      })
      .catch((error) => {
        console.log(error?.message);
        onError();
      });
  }

  static deleteExercise(id: any, onSuccess: () => void) {
    return axiosInstance
      .delete(generatePath(EXERCISES_ID, { id }))
      .then(() => {
        onSuccess();
      })
      .catch((error) => {
        console.log(error?.message);
      });
  }

  static updatePosition(id: any, payload: any, onSuccess: () => void) {
    return axiosInstance
      .put(
        generatePath(EXERCISE_POSITION, {
          id,
        }),
        payload
      )
      .then(() => {
        onSuccess();
      })
      .catch((error) => {
        console.log(error?.message);
      });
  }
  static uploadBulkExerciseQuestions(
    payload: any,
    onSuccess: () => void,
    onError: (errors: any, row: any) => void,
    onFinal: () => void
  ) {
    return axiosInstance
      .post(BULK_EXERCISE_QUESTIONS, payload, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        onSuccess();
      })
      .catch((error) => {
        const { response } = error;
        onError(response?.data[0]?.error, response?.data[0]?.row);
        Notification({
          message: "Uploading failed",
          description: "Something went wrong",
          type: NotificationTypes.ERROR,
        });
      })
      .finally(onFinal);
  }
  static uploadExerciseQuestionsDocument(
    payload: any,
    onSuccess: () => void,
    onError: (errors: any, row?: any) => void,
    onFinal: () => void
  ) {
    return _axiosInstance
      .post(BULK_EXERCISE_QUESTIONS_DOC, payload, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        if (response?.data?.isSuccess)
          onSuccess();
        else
          throw response?.data?.err
      })
      .catch((error) => {
        const { response } = error;
        if (response) {
          onError(response?.data[0]?.error, response?.data[0]?.row);
        } else if (Array.isArray(error)) {          
          onError(error, 'no_row');
        }
        Notification({
          message: "Uploading failed",
          description: "Something went wrong",
          type: NotificationTypes.ERROR,
        });
      })
      .finally(onFinal);
  }
}
